import { gql } from 'graphql-request'

export const getInvoiceExtract = gql`
  query getInvoiceExtract($contract: String!) {
    applications {
      invoiceExtract {
        invoiceExtractListData(contract: $contract) {
          number
          dueDate
          linkPdf
        }
      }
    }
  }
`